module.exports = __webpack_public_path__ + "static/img/autogood3.dd3cafc.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/newdownload/autogood3.png
// module id = ODev
// module chunks = 0